import { BannerWithTitleOnly } from "#app/_ui/components/banners/BannerWithTitleOnly";
import { LayoutOneFourth } from "#app/_ui/layouts/LayoutOneFourth";
import { Card, CardContent, CardHeader } from "#ui/card";
import { Container } from "#ui/container";
import { Icon } from "#ui/icon";
import { LinkButton } from "#ui/link";
import { Main } from "#ui/main";
import { H3 } from "#ui/typography";

export function MaintenanceLayout({
  children,
  title,
}: {
  children: React.ReactNode;
  title?: string | null | undefined;
}) {
  return (
    <Main>
      <BannerWithTitleOnly title={title ?? "Maintenance"} />
      <Container>
        <LayoutOneFourth
          reverse
          slot={
            <Card>
              <CardHeader palette="gray">
                <H3 size="h6" className="flex items-center gap-12px">
                  <Icon name="baird-help" size="baird-md" />
                  <span>Need Help?</span>
                </H3>
              </CardHeader>
              <CardContent className="space-y-10px py-20px">
                <div>
                  <LinkButton href="/contact-us" variant="link">
                    <span>Contact & FAQs</span>
                    <Icon name="ms-navigate-next" />
                  </LinkButton>
                </div>
                <div>
                  <LinkButton href="/my-team" variant="link">
                    <span>My Team</span>
                    <Icon name="ms-navigate-next" />
                  </LinkButton>
                </div>
              </CardContent>
            </Card>
          }
        >
          {children}
        </LayoutOneFourth>
      </Container>
    </Main>
  );
}
